import React, { Fragment } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./dashboard/header";
import Footer from "./dashboard/footer";
import Switcher from "./dashboard/switcher/switcher";
import "../index.scss";
import SideBar from "./dashboard/sidebar/sidebar";
import PrivateRoute from "./PrivateRoute";
import EmpSideBar from "./employee/sidebar/empsidebar";
import ManSideBar from "./manager/mansidebar";
import MemberSideBar from "./member/membersidebar";
// The staff member-management screens also live under /member/ (addmember,
// allmembers), so the member portal is matched by an explicit list rather than
// by prefix. The API enforces this too; this just keeps members off staff
// screens that would render empty and 403.
const MEMBER_PATHS = ["/member/dashboard", "/member/loans", "/member/outstanding"];

const App = () => {
  const location = useLocation();
  const isMember = localStorage.getItem("Role") === "5";
  const inMemberArea = MEMBER_PATHS.includes(location.pathname);

  document.querySelector("body").classList.remove("error-1");
  document
    .querySelector("body")
    .classList.remove("app", "sidebar-mini", "landing-page", "horizontalmenu");
  document.querySelector("body").classList.add("main-body", "leftmenu");
  const remove = () => {
    // document.querySelector(".sidebar-right").classList.remove("sidebar-open");
    document.querySelector("body").classList.remove("main-sidebar-show");
    document.querySelector(".demo_changer").classList.remove("active");
    document.querySelector(".demo_changer").style.right = "-270px";
  };

  if (isMember && !inMemberArea) {
    return <Navigate to="/member/dashboard" replace />;
  }

  return (
    <Fragment>
      <div className="horizontalMenucontainer">
        <Switcher />
        <div className="page">
          <Header />
          {/* 1 Super Admin, 2 Admin, 3 Manager, 4 Employee, 5 Member. Each
              sidebar builds its menu from the role's role_menu_access, so Admin
              and Manager can share a component and still show different menus. */}
          {localStorage.getItem("Role") === "1" && <SideBar />}
          {localStorage.getItem("Role") === "2" && <ManSideBar />}
          {localStorage.getItem("Role") === "3" && <ManSideBar />}
          {localStorage.getItem("Role") === "4" && <EmpSideBar />}
          {localStorage.getItem("Role") === "5" && <MemberSideBar />}


          <PrivateRoute />
          <div className="main-content side-content">
            <div
              className="main-container container-fluid"
              onClick={() => remove()}
            >
              <div className="inner-body">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </Fragment>
  );
};
export default App;
